import Breakpoints from 'breakpoints-js/src/breakpoints';
import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';
import productTileSlider from '../plp/rbata.tileSlider';

// Used for Recommendation and Merchandising slider
const MerchandisingCarousel = {
    sliders:  [],
    $wrapper: undefined,

    transformSlider(slider, nav) {
        this.sliders.push(tns({
            container:         slider,
            mode:              'carousel',
            items:             4,
            slideBy:           4,
            loop:              0,
            controls:          true,
            controlsContainer: nav,
            nav:               false,
            arrowKeys:         true,
            speed:             500,
            lazyload:          false,
            mouseDrag:         false,
            nested:            'outer',
            onInit:            () => {
                slider.classList.remove('product-carousel--not-initialized');
                mediaLazyLoad.refreshLazyLoad();
            },
        }));
    },

    destroySlider() {
        if (this.slider && typeof (this.slider.destroy) === typeof (Function)) {
            this.slider.destroy();
        }
    },

    buildSlider(currentContainer) {
        const hasMoreThan4Items = currentContainer.childElementCount > 4;
        const $container        = $(currentContainer);
        const $nav              = $container.next('nav');
        productTileSlider.reInit();
        if (hasMoreThan4Items) {
            //show the arrow if we have more products
            $nav.removeClass('d-none');
            //make it a real slider
            MerchandisingCarousel.transformSlider(currentContainer, $nav[0]);
        }
    },

    destroyAllSliders() {
        this.sliders.forEach((tns) => {
            if (tns && typeof (tns.destroy) === typeof (Function)) {
                tns.destroy();
                setTimeout(() => {
                    mediaLazyLoad.refreshLazyLoad();
                    productTileSlider.reInit();
                }, 0)
            }
        });
        this.sliders = [];
    },

    bindHandler() {
        Breakpoints.on('desktop', {
            enter: () => {
                MerchandisingCarousel.$wrapper = $('.js-merch-carousel')
                if (MerchandisingCarousel.$wrapper.length) {
                    MerchandisingCarousel.$wrapper.each((_, carousel) => {
                        MerchandisingCarousel.buildSlider(carousel)
                    })
                }
            },

            leave: () => {
                //it is not a problem if this is executed multiple times
                MerchandisingCarousel.destroyAllSliders();
            }
        });
    }
};

export default MerchandisingCarousel;

